import { useEffect, useState } from 'react';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import styles from './Pubslish.module.css';

export default function DropDown({
  selectedData,
  setSelectedData,
  apiCall,
  data,
  handleOpen,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  useEffect(() => {
    apiCall();
  }, []);
  const handleClickListItem = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (option) => {
    setSelectedData(option.value); // Store only the value
    handleClose();
  };

  const selectedName = data?.find((item) => item.value === selectedData)?.name
    || 'Select Category';

  return (
    <div>
      <List
        component="nav"
        aria-label="Category Dropdown"
        sx={{
          bgcolor: 'background.paper',
          border: '1px solid #ccc',
          borderRadius: 2,
          fontFamily: 'Montserrat, sans-serif', // ✅ add here
        }}
      >
        <ListItemButton
          id="category-button"
          aria-haspopup="listbox"
          aria-controls="category-menu"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClickListItem}
                        sx={{ fontFamily: 'Montserrat, sans-serif' }} // ✅ here too
        >
          {selectedName !== 'Select Category' && (
            <p className={styles.categoryHead}>Category:</p>
          )}
<ListItemText
  primary={selectedName}
  primaryTypographyProps={{
    fontFamily: 'Montserrat, sans-serif',
  }}
/>

        </ListItemButton>
      </List>

      <Menu
        id="category-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'category-button',
          role: 'listbox',
          sx: {
            fontFamily: 'Montserrat, sans-serif', // ✅ for menu items
          },
        }}
      >
        <MenuItem
          disableRipple
          disableTouchRipple
          sx={{
            color: '#5AA5EF',
            fontWeight: 500,
            fontFamily: 'Montserrat, sans-serif',
          }}
          onClick={handleOpen}
        >
          Add new
        </MenuItem>
        {data?.length > 0
          && data.map((option) => (
            <MenuItem
              key={option.value}
              selected={option.value === selectedData}
              onClick={() => handleMenuItemClick(option)}
              sx={{ fontFamily: 'Montserrat, sans-serif' }} // ✅ here too
            >
              {option.name}
            </MenuItem>
          ))}
      </Menu>
    </div>
  );
}
